<template>
  <div v-if="recommentCourseList.length > 0">
    <el-row>
      <el-col :span="24">
        <div class="recom-bg">
          <span class="recom-courses-title">推荐课程</span>
        </div>
      </el-col>
    </el-row>
    <!-- 图形卡片-->
    <el-row style="margin-top: 30px">
      <el-col :span="6" v-for="(item,i) in recommentCourseList" :offset="i%4 > 0 ? 1 : 0" :key="item.id">
        <cart :item="item"></cart>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import cart from '@/components/course/Cart'
  export default {
    name: "RecommendCourse",
    components: {
      cart:cart
    },
    props: {
      courseType: String
    },
    data() {
      return {
        recommentCourseList: []
      }
    },
    methods: {
      async getRecommendList() {
        const {content} = await this.$http.get("/business/web/course/recommendList",{params:{courseType:this.courseType}});
        this.recommentCourseList = content;
      }
    },
    mounted() {
      this.getRecommendList();
    }
  }
</script>

<style scoped>
  .recom-bg {
    padding-left: 20px;
    line-height: 55px;
    background: rgb(244, 244, 245);
    height: 55px;
  }
  .recom-courses-title {
    font-size: 20px;
    line-height: 27px;
    font-weight: bold;
    color: #606266;
  }
  /*修改卡片自带的内边距*/
  .el-card /deep/ .el-card__body {
    padding: 0;
  }

  .el-col-6{
    width: 23.5%;
  }
  .el-col-offset-1{
    margin-left: 2%;
  }
</style>
